import styled from "styled-components";
import { Button } from "../Button";
import { colors } from "../../styles/variables";

interface StyledBannerDetails {
  isError: boolean;
}

export const StyledBanner = styled.div<StyledBannerDetails>`
  display: flex;
  justify-content: center;

  ${({ isError, theme }) =>
    isError
      ? `
        background-color: ${colors.orange};
      `
      : `
      background-color: ${theme.banner?.backgroundColor || colors.green};
      `}
`;

export const StyledInnerWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  color: ${colors.white};
  text-align: center;
  padding: 0 20px;

  Button {
    padding-left: 10px;
    color: ${colors.white};
    text-decoration: underline;
    font-family: font-primary, sans-serif;
    font-weight: 400;
  }
`;

export const StyledButton = styled(Button)`
  padding-left: 3px;
  color: ${colors.white};
  text-decoration: underline;
`;

export const StyledContent = styled.p`
  margin: 10px 0;
`;
